/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { DocumentCategory } from '../utils/Interface/DocumentCategory';
import useSpecialToken from '../utils/hooks/useSpecialToken';
import apiRoutes from '../utils/hooks/apiRoutes';

import TabsNav from "../components/TabsNav";
import Menu from "../components/Menu";
import Header from "../components/Header";
import Button from "../components/Button";
import InputField from "../components/InputField";
import PopUp from '../components/PopUp';
import "../style/css/doccategoryconfig.css";
import "../style/css/newmodeldoc.css";
import '../style/css/editmodeldocuments.css';

import EditorText from '../components/EditorText';

interface EditModelProps {}

const EditModel: React.FC<EditModelProps> = () => {

  const { userName, specialToken } = useSpecialToken();
  const { modelId } = useParams<{ modelId: string }>();
  const [selectedModelName, setSelectedModelName] = useState<string>('');
  const [selectedModelTitle, setSelectedModelTitle] = useState<string>('');
  const [selectedModelObject, setSelectedModelObject] = useState<string>('');
  const [selectedModelContent, setSelectedModelContent] = useState<string>('');
  const [categoriesDoc, setCategoriesDoc] = useState<DocumentCategory[]>([]);
  const [selectCat, setSelectCat] = useState<{ text: string; id: number }[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
  const [editorFocused, setEditorFocused] = useState<boolean>(false);

 //useEffect & fetch data

  useEffect(() => {
    if (specialToken) {
      fetchData();
      fetchDataCat();
    }
  }, [specialToken, modelId]);

  const fetchData = async () => {

    try {

      const headers: HeadersInit = specialToken
      ? {
          'Content-Type': 'application/json',
          'special-token': specialToken,
        }
      : {
          'Content-Type': 'application/json',
        };


      if (!modelId) {
        throw new Error('ID d\'attribution non valide');
      }

      const getOneUrl = apiRoutes.documentsModelsGetOne.replace(':id', `${modelId}`);
      const response = await fetch(getOneUrl, { headers });

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const jsonData = await response.json();
      setSelectedModelName(jsonData.name);
      setSelectedModelTitle(jsonData.title);
      setSelectedModelObject(jsonData.object);
      setSelectedModelContent(jsonData.content);
      console.log(selectedModelContent);
      setSelectedCategoryId(jsonData.glpi_documents_categories_id);

    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }

  };

  const fetchDataCat = async () => {

    try {
      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }

      const headers = {
        'Content-Type': 'application/json',
        'special-token': specialToken
      };

      const response = await fetch(apiRoutes.documentsCategoriesGetAll, { headers });

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const jsonData = await response.json();
      setCategoriesDoc(jsonData);

      const options = jsonData.map((item: DocumentCategory) => ({
        text: item.name,
        id: item.id,
      }));

      setSelectCat(options);

    } catch (error) {
      console.error('Erreur lors de la récupération des catégories de documents :', error);
    }

  };

  //handleclick, delete, put

  const handleDelete = async () => {

    try {

      if (!modelId) {
        throw new Error('Aucun modèle sélectionné.');
      }

      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }

      const deleteOneUrl = apiRoutes.documentsModelsDelete.replace(':id', `${modelId}`);
      const response = await fetch(deleteOneUrl, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'special-token': specialToken
        },
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la suppression du modèle');
      }

      alert('Modèle supprimé avec succès!');
      fetchData();
      window.location.href = '/configuration/documents/modeles';

    } catch (error) {
      console.error('Erreur lors de la suppression du modèle :', error);
    }

  };

  const handleSaveInput = async () => {

    try {

      if (!specialToken) {
        throw new Error('Special token is null or undefined');
      }

      if (!modelId) {
        throw new Error('ID d\'attribution non valide');
      }

      const putUrl = apiRoutes.documentsModelsPut.replace(':id', `${modelId}`);
      const response = await fetch(putUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'special-token': specialToken
        },
        body: JSON.stringify({
          name: selectedModelName,
          title: selectedModelTitle,
          object: selectedModelObject,
          content: selectedModelContent,
          glpi_documents_categories_id: selectedCategoryId,
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la sauvegarde des données');
      }

      alert('Modèle modifié avec succès !');
      window.location.href = '/configuration/documents/modeles';

    } catch (error) {
      console.error('Erreur lors de la sauvegarde des données :', error);
    }

  };

  const handleEditorFocus = () => {
    setEditorFocused(true);
  };

  const handleCancel = () => {
    window.location.href = '/configuration/documents/modeles';
  };

  return (
    <div className="mainnewmodel">

      <div className="mainnewmodel__box1">
        
        <Header userName={userName} />
        
        <div className="mainnewmodel__box1__container">
          
          <h2 className="mainnewmodel__box1__container__title"> Modifier le modèle </h2>
          
          <TabsNav 
          tab1="Catégorie" 
          tab2="Modèle" 
          path1="/configuration/documents/categories" 
          path2="/configuration/documents/modeles" 
          additionalPathsForTab2={['/configuration/documents/modeles/nouveau']} 
          additionalPathsForTab22={['/configuration/documents/modeles/modifier/:id']} />
          
          <form className="mainnewmodel__box1__container__form">
            
            <h5 className="mainnewmodel__box1__container__form__title"> Informations générales</h5>
            
            <InputField 
            labels={[{ title: "Nom du modèle" }]} 
            onChange={(newValue) => setSelectedModelName(newValue[0])} 
            initialValue={[selectedModelName]} />
            
            <InputField 
            labels={[{ title: "Titre du document" }]} 
            onChange={(newValue) => setSelectedModelTitle(newValue[0])} 
            initialValue={[selectedModelTitle]} />
            
            <InputField 
            labels={[{ title: "Objet du document" }]} 
            onChange={(newValue) => setSelectedModelObject(newValue[0])} 
            initialValue={[selectedModelObject]} />
          
          </form>

          <h3 className="mainnewmodel__box1__container__subtitle"> Corps du document</h3>

          <div className="mainnewmodel__box1__container__editor">

            <EditorText
              initialValue={selectedModelContent}
              onEditorChange={(content) => setSelectedModelContent(content)}
              onFocus={handleEditorFocus}/>   
          
          </div>

          <div className="mainnewmodel__box1__container__btn">

            <Button 
            btnName={" Sauvegarder"} 
            onClick={handleSaveInput}
            disable={false} />

            <PopUp 
            onDeleteClick={handleDelete} />

            <Button 
            btnName={"Annuler"} 
            onClick={handleCancel}
            disable={false} />

          </div>

        </div>

      </div>

      <div className="mainnewmodel__menu">
        <Menu />
      </div>

    </div>
  );
}

export default EditModel;
